
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VerifyCodePage from "./VerifyCodePage";

const API_BASE = "https://api.dev1.auth.joeandalese.com/v1";

function LoginPage({ onShowRegister }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);
  const [showCodeEntry, setShowCodeEntry] = useState(false);
  const [sessionChecking, setSessionChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE}/me`, { credentials: "include" })
      .then(r => { if (r.ok) navigate("/home"); })
      .catch(() => {})
      .finally(() => setSessionChecking(false));
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError("Please enter a valid email address.");
      return;
    }
    setChecking(true);
    try {
      const resp = await fetch(`${API_BASE}/verify-user-exists`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email })
      });
      const data = await resp.json();
      if (!data.userExists) {
        if (typeof onShowRegister === "function") onShowRegister(email);
      } else {
        try {
          const loginResp = await fetch(`${API_BASE}/send-login-code`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ email })
          });
          const loginData = await loginResp.json();
          if (!loginResp.ok) {
            setError(loginData.error || loginData.message || "Failed to send login code.");
            return;
          }
          setShowCodeEntry(true);
        } catch {
          setError("Failed to send login code. Please try again.");
        }
      }
    } catch {
      setError("Error verifying user. Please try again.");
    }
    setChecking(false);
  };

  if (sessionChecking) return null;

  if (showCodeEntry) {
    return <VerifyCodePage email={email} />;
  }
  return (
    <div style={{ maxWidth: 400, margin: "80px auto", padding: 24, border: "1px solid #eee", borderRadius: 8, boxShadow: "0 2px 8px #f0f1f2" }}>
      <h2 style={{ textAlign: "center" }}>Login</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="email">Email Address</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{ width: "100%", padding: 8, margin: "8px 0 16px 0", borderRadius: 4, border: "1px solid #ccc" }}
          required
          autoFocus
        />
        {error && <div style={{ color: "#d32f2f", marginBottom: 8 }}>{error}</div>}
        <button type="submit" style={{ width: "100%", padding: 10, background: checking ? "#aaa" : "#1976d2", color: "#fff", border: "none", borderRadius: 4, fontWeight: 600 }} disabled={checking}>
          {checking ? "Checking..." : "Login"}
        </button>
      </form>
    </div>
  );
}

export default LoginPage;
